import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Hidden from "@material-ui/core/Hidden";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import ReportBar from 'components/SearchBar/ReportBar.jsx';
import ReportCard from 'components/Card/ReportCard.jsx';
import Paginator from 'components/Controls/Paginator.jsx';
import Snackbar from "components/Snackbar/Snackbar.jsx";
import iconsStyle from "assets/jss/material-dashboard-react/views/iconsStyle.jsx";
import { refreshToken, APIRoot } from 'variables/authentication.jsx';
import { sortables, sort_modes } from 'variables/sortables.jsx';

import Api from 'services/api';
//dev
const ReportedAPIRoot = APIRoot + "/reported-items";

class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      snackbar_open: false,
      snackbar_message: "",
      reported_data: [],
      page: 0,
    }
    this.reloadData = this.reloadData.bind(this);
    this.updatePage = this.updatePage.bind(this);
    this.message = this.message.bind(this);
    this.reloadData();
  }

  updatePage(pageNum) {
    this.setState({ page: this.state.page + pageNum }, () => {
      this.reloadData();
    });
  }

  message(message) {
    this.setState({
      snackbar_open: true,
      snackbar_message: message
    })
  }


  async reloadData(secondChance = true) {
    const responseData = await Api({ endpoint: '/reported-items' });

    this.setState({ reported_data: responseData })

  }

  render() {
    const { classes } = this.props;
    return (

      <div>
        <Snackbar
          message={this.state.snackbar_message}
          color="warning"
          open={this.state.snackbar_open}
          close={true}
          place={"tc"}
          closeNotification={() => { this.setState({ snackbar_open: false }) }}
        />
        <ReportBar onChange={this.Search}
        />
        <GridContainer>
          {this.state.reported_data.map((element, i) =>
            <GridItem xs={3} sm={3} md={3} key={element.id}>
              <ReportCard report_data={element} message={this.message} />
            </GridItem>
          )}
        </GridContainer>
        <Paginator
          updatePage={this.updatePage}
          page={this.state.page}
          rightDisabled={this.state.reported_data.length < 20}
        />
      </div>
    );
  }
}


Reports.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(iconsStyle)(Reports);
